import { Component, OnInit } from '@angular/core';
import { SystemService } from '../../services/system.service';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { IApplicant } from 'src/app/shared/classes/applicant';
import { CaseService } from '../../services/case.service';
import { UtilitiesService } from '../../services/utilities.service';


@Component({
  selector: 'app-applicant',
  templateUrl: './applicants.component.html'
})
export class ApplicantsComponent implements OnInit {

    isNewEntry = false;
    cols: any[];
    applicantList: IApplicant[];
    myApplicant: IApplicant;

    displayState: any = {
        workingDiv: false,
        applicantsDiv: false,
        gridDiv: false,
        editApplicantDiv: false,
        saveDisabled: false
    };
    filterOptions: any = {
        filterText: '',
    }

    constructor(private systemService: SystemService, private messageService: MessageService, private confirmationService: ConfirmationService, private caseService: CaseService,
            private utilService:UtilitiesService) { }

    ngOnInit() {
        this.cols = [
            { field: 'name', displayName: 'Applicant Name', width: 280, sortable: true },
            { field: 'strAddr', displayName: 'Address', width: 140, sortable: false },
            { field: 'city', displayName: 'City', width: 120, sortable: true },
            { field: 'state', displayName: 'State', width: 50, sortable: true },
            { field: 'zip', displayName: 'Zip', width: 75, sortable: true },
            { field: 'phone', displayName: 'Phone', width: 100, sortable: true },
            { field: 'altPhone', displayName: 'Alt Phone', width: 85, visible: false },
            { field: 'fax', displayName: 'Fax', visible: false },
            { field: 'email', displayName: 'Email', width: 175, sortable: true },
            { field: 'id', displayName: 'ID', sortable: false, visible: false }
        ];
        
        this.loadApplicantList();
    }

    loadApplicantList() {
        this.displayState.gridDiv = false;
        this.displayState.workingDiv = true;
        this.caseService.getApplicantList().subscribe (data => {
            //this.utilService.doAudit(data, 'load applicant list');
            this.applicantList = data;
            this.filterOptions.filterText = ''; // clear any filters...
            this.displayState.workingDiv = false;
            this.displayState.gridDiv = true;
        });
    }

    selectApplicant(applicant: IApplicant) {
        this.displayState.workingDiv = true;
        this.caseService.getApplicant(applicant.id.toString()).subscribe(data => {
            this.myApplicant = data;
            this.displayState.workingDiv = false;
            this.displayState.gridDiv = false;
            this.displayState.editApplicantDiv = true;
            //this.utilService.doAudit(data,'selected applicant id: '+applicant.id)
        });
    }

    initApplicant() {
        this.myApplicant = {
            id: 0,
            name: "",
            lastName: "",
            firstName: "",
            strAddr: "", 
            city: "",
            state: "",
            zip: "",
            phone: "",
            altPhone: "",
            fax: "",
            email: "",
            type: "",
            sign: false,
            notNotarized: false
        }
    }
    newApplicant() {
        this.initApplicant();
        this.displayState.workingDiv = false;
        this.displayState.gridDiv = false;
        this.displayState.editApplicantDiv = true;
    }

    deleteApplicant(applicant: IApplicant) {
        this.utilService.doAudit(applicant, 'delete applicant');
        this.confirmationService.confirm({
        message: 'Do you want to delete this record?',
        header: 'Delete Confirmation',
        icon: 'pi pi-info-circle',
        accept: () => {
            this.caseService.deleteApplicant(applicant.id.toString()).subscribe(data => {
                this.showToast({severity: 'success', detail: 'Applicant has been DELETED.', summary: ''});
                this.loadApplicantList();
            });
        },
        reject: () => {
            this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
        }
        });
    }

    saveApplicant() {
        this.utilService.doAudit(this.myApplicant, 'save applicant');
        this.caseService.saveApplicant(this.myApplicant).subscribe(data => {
            this.showToast({severity: 'success', detail: 'Applicant has been Saved.', summary: ''});
            this.loadApplicantList();
            this.displayState.workingDiv = false;
            this.displayState.editApplicantDiv = false;
            this.displayState.gridDiv = true;
        });
    }

    // determine if all the required fields have been filled in
    applicantNeedRequiredData() {
        if (this.myApplicant === null ) {
            return true;
        }
        if ( (this.myApplicant.name.length < 1) || (this.myApplicant.phone.length < 1) ) {
            return true;
        }
        else {
            return false;
        }
    }

    cancelEntry() {
        this.displayState.workingDiv = false;
        this.displayState.editApplicantDiv = false;
        this.filterOptions.filterText = ''; // clear any filters...
        this.displayState.gridDiv = true;
        return;
    }

    showToast(msg: Message) {
        this.messageService.add(msg);
    }

    clear() {
        this.messageService.clear();
    }
}
